import $ from 'jquery';

function onDocumentReady() {
	$(document).on('click', '.video-link', onClickVideo);
}

function onClickVideo(e) {
	const clicked = $(e.currentTarget);

	$.magnificPopup.open({
		items: {
			src: clicked.attr('href'),
			type: 'iframe',
		},
        iframe: {
            patterns: {
                wistia: {
                index: 'wistia.com',
                id: function(url) {
                    var m = url.match(/^.+wistia.com\/(medias)\/([^_]+)[^#]*(#medias=([^_&]+))?/);
                    if (m !== null) {
                        if(m[4] !== undefined) {
                            return m[4];
                        }
                        return m[2];
                    }
                    return null;
                },
                src: '//fast.wistia.net/embed/iframe/%id%?autoPlay=1'
                }
            }
        }
	});

	e.preventDefault();

	return false;
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
